import { render, staticRenderFns } from "./ShareComponentButton.vue?vue&type=template&id=07233978&"
import script from "./ShareComponentButton.vue?vue&type=script&lang=js&"
export * from "./ShareComponentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports